import { render, staticRenderFns } from "./RS_changeDetection.vue?vue&type=template&id=189185b2"
import script from "./RS_changeDetection.vue?vue&type=script&lang=js"
export * from "./RS_changeDetection.vue?vue&type=script&lang=js"
import style0 from "./RS_changeDetection.vue?vue&type=style&index=0&id=189185b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports